module.exports = __webpack_public_path__ + "img/mark_spike.694447cd.jpg";